import moment from "moment";
import React from "react";
import { Badge } from "reactstrap";
import {
  CLIENT_REQUEST_APPROVED_ID,
  CLIENT_REQUEST_IN_COMPLETE_CLIENT_ACTIONS_ID,
  CLIENT_REQUEST_IN_PROGRESS_CLIENT_ACTIONS_ID,
  CLIENT_REQUEST_PENDING_CLIENT_ACTIONS_ID,
  CLIENT_REQUEST_PENDING_ID,
  CLIENT_REQUEST_REJECTED_ID,
} from "../constants";
import { mustBeArray } from "./lib";

// Single source of truth for status display text, shared by the results badge and the
// Status filter dropdown so the two never disagree.
export const getClientRequestStatusLabel = ({ statusId, fallbackName }) => {
  switch (statusId) {
    case CLIENT_REQUEST_APPROVED_ID:
      return "Waiting to be scheduled";
    case CLIENT_REQUEST_REJECTED_ID:
      return "Cancelled";
    case CLIENT_REQUEST_IN_COMPLETE_CLIENT_ACTIONS_ID:
      return "Completed";
    case CLIENT_REQUEST_IN_PROGRESS_CLIENT_ACTIONS_ID:
      return "In Progress";
    default:
      return fallbackName || statusId;
  }
};

const getClientRequestStatusColor = ({ statusId }) => {
  switch (statusId) {
    case CLIENT_REQUEST_APPROVED_ID:
      return "warning";
    case CLIENT_REQUEST_PENDING_ID:
      return "primary";
    case CLIENT_REQUEST_REJECTED_ID:
      return "danger";
    case CLIENT_REQUEST_PENDING_CLIENT_ACTIONS_ID:
      return "info";
    case CLIENT_REQUEST_IN_PROGRESS_CLIENT_ACTIONS_ID:
      return "success";
    case CLIENT_REQUEST_IN_COMPLETE_CLIENT_ACTIONS_ID:
      return "default";
    default:
      return "default";
  }
};

export const getClienRequestBadge = ({ statusId, statusName }) => {
  return (
    <Badge className={`py-q px-q`} color={getClientRequestStatusColor({ statusId })}>
      {String(getClientRequestStatusLabel({ statusId, fallbackName: statusName })).toUpperCase()}
    </Badge>
  );
};

export const getClientRequestActionType = ({ action }) => {
  switch (action) {
    case "approve":
      return CLIENT_REQUEST_APPROVED_ID;
    case "pending":
      return CLIENT_REQUEST_PENDING_CLIENT_ACTIONS_ID;
    case "deny":
      return CLIENT_REQUEST_REJECTED_ID;      
    default:
      return null;
  }
};

export const getClientRequestActionMessage = ({ action }) => {
  switch (action) {
    case "approve":
      return "Approving client request.";
    case "pending":
      return "Pending action from client.";
    case "deny":
      return "Declining client request.";
    default:
      return "Saving client request.";
  }
};

// Expected volume to avoid charges on urgent collection
export const isCollectionExpectedVolumeMet = ({
  list,
  selectedCollection,
  autoApproveUrgentRunEstimate,
}) => {
  const location = mustBeArray(list).find(
    (o) => o.locationId === selectedCollection
  );
  return location && location.estimated >= autoApproveUrgentRunEstimate ? true : false;
};

// Expected tank volumne or installation date to avoid charges
export const isTankExpectedVolumeMet = ({tanks, selectedTank, vacuumMonths, standardMonths, litres}) => {
  const location = mustBeArray(tanks).find((o) => o.tankId === selectedTank);
  if (!location) return false;
  const getMonthsDifference = moment().diff(
    moment(location.installationDate),
    "months"
  );
  if (location.driverLitresPickedUpTotal >= litres) return true;
  if (location.isVacuum && getMonthsDifference >= vacuumMonths) return true;
  if (!location.isVacuum && getMonthsDifference >= standardMonths) return true;
  return false;
};
